import { Button } from '@azelis/ui/components/button';
import { PageSection } from '@azelis/ui/components/pageSection';
import { Link, useParams } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { useDownloadExcel, useQuestionnaireResult } from '@/api/questionnaires';
import { QuestionView } from '@/components/question-view/question-view';

export default function ResultDetail() {
  const { id } = useParams({ from: '/app/overview/$id' });
  const { data, isLoading, error } = useQuestionnaireResult(id);
  const excelDownload = useDownloadExcel();

  if (isLoading) {return <p className="text-sm text-muted-foreground">Loading...</p>;}
  if (error || !data) {
    return (
      <p className="text-sm text-muted-foreground">
        No response available for this questionnaire yet.
      </p>
    );
  }

  return (
    <PageSection>
      <div className="flex w-full items-center justify-between">
        <h1 className="text-lg font-semibold">
          {data.product_id} - {data.product_name} ({data.country})
        </h1>
        <Button
          variant="outline"
          disabled={excelDownload.isPending}
          onClick={() => {
            excelDownload.mutate(id);
          }}>
          {excelDownload.isPending ? 'Preparing…' : 'Download Excel'}
        </Button>
      </div>

      <Button
        variant="ghost"
        size="sm"
        className="self-start"
        render={<Link to="/app/overview" />}>
        <ArrowLeft />
        Back to overview
      </Button>

      {excelDownload.isError && (
        <p className="w-full text-sm text-destructive-foreground">
          No filled Excel file is available (the source questionnaire may not have been Excel).
        </p>
      )}

      {data.pages.map((page, pageIndex) => (
        <section
          key={pageIndex}
          className="flex w-full flex-col gap-4">
          {page.questions.map((question, index) => (
            <QuestionView
              key={index}
              question={question}
            />
          ))}
          {page.table_questions.map((question, index) => (
            <QuestionView
              key={`table-${index}`}
              question={question}
              isTable
            />
          ))}
        </section>
      ))}
    </PageSection>
  );
}
